module.exports = "/images/Greece.png?dba428f9c8468a2d53c4df6092ffe2de";